import makeStyles from "@mui/styles/makeStyles";
import { DialogActionsProps } from "./DialogActions.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    padding: "0 16px 16px 16px",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      padding: "0 24px 24px 24px",
    },
  },
  extra: {
    padding: 0,
  },
  actions: (props: DialogActionsProps) => ({
    flex: 1,
    padding: 0,
    justifyContent: props.justifyContent,
    marginTop: props.marginTop,
    [theme.breakpoints.up("md")]: {
      width: "initial",
    },
  }),
}));
